import { MessageCircle } from 'lucide-react'
import { getWhatsAppSalesUrl } from '@/utils/contactLinks'

export default function FloatingWhatsAppButton() {
  const whatsappUrl = getWhatsAppSalesUrl(
    'Hola IridiaChat, estoy navegando en la web y me gustaría probar el bot o solicitar una invitación.'
  )

  return (
    <div className="fixed bottom-6 right-6 z-40 flex items-center gap-3">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chatear con el equipo de ventas por WhatsApp"
        className="group relative flex items-center gap-2.5 bg-emerald-500 hover:bg-emerald-600 text-white pl-4 pr-5 py-3 rounded-full shadow-xl shadow-emerald-900/20 hover:shadow-2xl hover:shadow-emerald-900/30 transition-all duration-300 hover:scale-105 active:scale-95 border border-emerald-400/40"
      >
        {/* Pulse indicator */}
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-100 opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
        </span>

        <MessageCircle className="w-5 h-5 text-white" />

        <div className="flex flex-col text-left">
          <span className="text-[10px] uppercase font-bold tracking-wider text-emerald-100 leading-tight">
            ¿Dudas o Demo?
          </span>
          <span className="text-xs font-extrabold leading-tight">
            Chatea en WhatsApp
          </span>
        </div>
      </a>
    </div>
  )
}
